import * as net from '~/lib/net';
import * as schemas from './schemas';
import { getToken } from '~/apps/shared/services/token';
import { DepartmentEndpoints } from "~/apps/shared/apis/endpoints";

export const getDepartmentById = async (id: string) => {
  const data = await net.apiGet(DepartmentEndpoints.getDepartmentById(id), getToken());
  return schemas.DepartmentSchema.load(data);
}

export const getDepartments = async () => {
  const data = await net.apiGet(DepartmentEndpoints.getDepartments(), getToken());
  return schemas.DepartmentListSchema.load(data);
}
